/* eslint-disable max-len */
import { GamesTranslations } from '../interfaces/games';

// Reguły gier wymieniają przyciski ich nazwami z `buttons` — przy zmianie nazwy przycisku poprawić też reguły
const PolishGamesTranslations: GamesTranslations = {
  names: {
    repeat: 'Powtórz',
    find: 'Znajdź',
    pick: 'Wybierz',
    pairing: 'Sparuj',
    memory: 'Memory',
    recognize: 'Rozpoznaj słowo',
    recognize2: 'Rozpoznaj tłumaczenie',
    recognizeEasy: 'Przeczytaj i powiedz co to znaczy',
    recognize2Easy: 'Powiedz po angielsku',
    dragLetters: 'Ułóż słowa',
    writing: 'Napisz',
    letters: 'Literuj',
  },
  buttons: {
    go: 'START',
    pause: 'PAUZA',
    sound: 'posłuchaj',
    skip: 'POMIŃ',
    next: 'DALEJ',
    check: 'SPRAWDŹ',
    clear: 'WYCZYŚĆ',
    repeat: 'POWTÓRZ',
    correct: 'DOBRZE',
    iWasRight: 'MAM RACJĘ',
    iWasRightEasy: 'mam rację',
    repeatGame: 'JESZCZE RAZ',
    nextGame: 'NASTĘPNA GRA',
    rules: 'Reguły gry',
    editList: 'Edytuj całą listę',
    editTerm: 'Edytuj zwrot',
    spell: 'LITERUJ',
  },
  labels: {
    skipWord: 'Pomiń słowo',
    clearAndRetry: 'Wyczyść i spróbuj ponownie',
    iWasRightNext: 'Mam rację — następne słowo',
    repeatWord: 'Powtórz słowo',
    nextWord: 'Następne słowo',
    playWord: 'Odsłuchaj hasło',
    readPolish: 'Przeczytaj po polsku',
    readEnglish: 'Przeczytaj po angielsku',
    letterSlot: 'Pozycja {{n}}',
    moreOptions: 'Więcej opcji',
    markRightWord: 'Zaznacz właściwe słowo',
    choose: 'Wybierz',
    wordImage: 'obrazek słowa',
    cardImage: 'obrazek karty',
  },
  states: {
    loadingList: 'Ładowanie listy...',
    noActiveList: 'Brak aktywnej listy',
    chooseList: 'Wybierz listę słówek, aby rozpocząć grę',
    backToLists: 'Wróć do list',
    dataError: 'Błąd danych',
    wordLoadError: 'Nie można załadować słówka',
    noWords: 'Brak słów w liście.',
  },
  writingPlaceholder: 'wpisz tłumaczenie',
  choosePicture: 'Kliknij właściwy obrazek:',
  polishNarrator: {
    label: 'Polski lektor: ',
    on: 'włączony',
    off: 'wyłączony',
  },
  audioError: 'Brak połączenia z lektorem – gra działa dalej bez dźwięku.',
  rules: {
    repeat: {
      title: 'Moduł POWTÓRZ: ',
      items: [
        'Wciśnij przycisk START, aby kolejno zobaczyć i usłyszeć wszystkie słowa znajdujące się na liście. Elementy pojawiają się w losowej kolejności w każdej grze.',
        'Lektor czyta każde słowo po angielsku. Jeśli w opcjach gry polski lektor jest włączony, przed angielskim słowem przeczyta też jego polskie znaczenie.',
        'Po każdym słowie lub zdaniu jest chwila ciszy. Powtórz je wtedy na głos po angielsku, zanim pojawi się następne.',
        'W dowolnym momencie można zatrzymać prezentację przyciskiem PAUZA. Przy ponownym uruchomieniu słowo zostanie powtórzone, zanim zostanie pokazane następne słowo z listy.',
        'Po zakończeniu listy można w razie potrzeby odtworzyć całość ponownie. Szczególnie jeśli dopiero zaczynasz uczyć się listy lub sprawia ci ona trudność.',
      ],
    },
    find: {
      title: 'Moduł ZNAJDŹ: ',
      items: [
        'Rozpoznaj po wymowie, które słowo z listy zostało odczytane. Jeśli nie usłyszałeś, uruchom wymowę przyciskiem POSŁUCHAJ.',
        'Kliknij na grafikę/zdjęcie, które odpowiada temu słowu. Pod obrazkami są ich polskie znaczenia.',
        'Jeśli wybór był poprawny, zostanie pokazane kolejne słowo. Jeśli nie, lektor przeczyta po angielsku słowo z klikniętego obrazka — ponów próbę.',
        'Jeśli w opcjach gry polski lektor jest włączony, po każdym kliknięciu obrazka lektor przeczyta też jego polskie znaczenie.',
        'INFO: Błąd powoduje ponowne wyświetlenie danego słowa na koniec gry.',
      ],
    },
    findEasy: {
      title: 'Moduł ZNAJDŹ: ',
      items: [
        'Rozpoznaj po wymowie, które słowo z listy zostało odczytane. Jeśli nie usłyszałeś, uruchom wymowę przyciskiem POSŁUCHAJ.',
        'Kliknij na obrazek, który odpowiada temu słowu.',
        'Głośnik w rogu obrazka czyta jego polskie znaczenie. Kliknięcie głośnika nie jest odpowiedzią.',
        'Jeśli wybór był poprawny, zostanie pokazane kolejne słowo. Jeśli nie, lektor przeczyta po angielsku słowo z klikniętego obrazka — ponów próbę.',
        'Jeśli w opcjach gry polski lektor jest włączony, po każdym kliknięciu obrazka lektor przeczyta też jego polskie znaczenie.',
        'INFO: Błąd powoduje ponowne wyświetlenie danego słowa na koniec gry.',
      ],
    },
    pick: {
      title: 'Moduł WYBIERZ: ',
      items: [
        'Kliknij na słowo odpowiadające widocznej grafice/zdjęciu. Pod obrazkiem jest jego polskie znaczenie.',
        'Po każdym kliknięciu lektor przeczyta wybrane słowo po angielsku, a jeśli w opcjach gry polski lektor jest włączony — także po polsku.',
        'Jeśli wybór był poprawny, zostanie pokazany kolejny obraz. Jeśli nie, ponów próbę.',
        'INFO: Błąd powoduje ponowne wyświetlenie danego słowa na koniec gry.',
      ],
    },
    pickEasy: {
      title: 'Moduł WYBIERZ: ',
      items: [
        'Kliknij na słowo odpowiadające widocznemu obrazkowi.',
        'Głośnik w rogu obrazka czyta po angielsku słowo, którego szukasz — skorzystaj z niego, jeśli nie pamiętasz. Kliknięcie głośnika nie jest odpowiedzią.',
        'Po każdym kliknięciu słowa lektor przeczyta je po angielsku, a jeśli w opcjach gry polski lektor jest włączony — także po polsku.',
        'Jeśli wybór był poprawny, zostanie pokazany kolejny obraz. Jeśli nie, ponów próbę.',
        'INFO: Błąd powoduje ponowne wyświetlenie danego słowa na koniec gry.',
      ],
    },
    pairing: {
      title: 'Moduł SPARUJ: ',
      items: [
        'Na planszy rozrzucone są plakietki ze słowami/zwrotami i obrazki. Jedne i drugie można przesuwać.',
        'Zadaniem jest przenieść PLAKIETKĘ ze zwrotem NA odpowiadający jej obrazek — mniej więcej jedna trzecia plakietki musi znaleźć się na obrazku.',
        'Kliknięty obrazek obróci się na chwilę i pokaże polskie znaczenie.',
        'Jeśli wybór był poprawny, lektor przeczyta słowo po angielsku (i po polsku, jeśli w opcjach gry polski lektor jest włączony), a potem para zniknie. Jeśli nie — próbuj dalej.',
        'Celem jest usunięcie wszystkich plakietek ze słowami.',
        'INFO: Jeśli lista jest dłuższa niż 10 elementów, karty zostaną rozdzielone na mniejsze grupy.',
      ],
    },
    pairingEasy: {
      title: 'Moduł SPARUJ: ',
      items: [
        'Na planszy rozrzucone są plakietki ze słowami/zwrotami i obrazki. Jedne i drugie można przesuwać.',
        'Zadaniem jest przenieść PLAKIETKĘ ze zwrotem NA odpowiadający jej obrazek — mniej więcej jedna trzecia plakietki musi znaleźć się na obrazku.',
        'Po kliknięciu w obrazek lektor przeczyta jego polskie znaczenie.',
        'Jeśli wybór był poprawny, lektor przeczyta słowo po angielsku (i po polsku, jeśli w opcjach gry polski lektor jest włączony), a potem para zniknie. Jeśli nie — próbuj dalej.',
        'Celem jest usunięcie wszystkich plakietek ze słowami.',
        'INFO: Jeśli lista jest dłuższa niż 5 elementów, karty zostaną rozdzielone na mniejsze grupy.',
      ],
    },
    memory: {
      title: 'Moduł MEMORY: ',
      items: [
        'Jest to klasyczna gra memory: kliknięcie elementu spowoduje odwrócenie karty.',
        'Połowa kart to obrazki, połowa to karty z angielskimi słowami. Odwrócony obrazek wypowiada swoje słowo po angielsku, karta ze słowem jest bez dźwięku.',
        'Celem jest odwrócenie wszystkich odpowiadających sobie par słowo-obraz. Poprawny wybór wyłącza z gry dane elementy.',
        'INFO: Jeśli lista jest dłuższa niż 9 elementów, karty zostaną rozdzielone na mniejsze grupy.',
      ],
    },
    memoryEasy: {
      title: 'Moduł MEMORY (Easy): ',
      items: [
        'Jest to klasyczna gra memory: kliknięcie karty spowoduje jej odwrócenie.',
        'Połowa kart to obrazki, połowa to karty z dźwiękiem, oznaczone głośnikiem. Gra nie pokazuje napisów.',
        'Odwrócona karta z głośnikiem wypowiada swoje słowo po angielsku. Obrazek jest bez dźwięku.',
        'Celem jest odnalezienie par dźwięk-obrazek: karty z głośnikiem i obrazka, który pokazuje to samo słowo. Odnaleziona para wyłącza się z gry.',
        'Po odnalezieniu pary lektor przeczyta polskie tłumaczenie słowa — o ile w opcjach gry polski lektor jest włączony.',
        'INFO: Jeśli lista ma więcej niż 4 słowa, karty zostaną podzielone na grupy po 4 pary. Ostatnią grupę w razie potrzeby uzupełniają słowa z wcześniejszych, więc niektóre pary pojawią się drugi raz.',
      ],
    },
    recognize: {
      title: 'Moduł ROZPOZNAJ SŁOWO: ',
      items: [
        'Jeśli rozpoznajesz znaczenie wyświetlonego słowa, świetnie. Kliknij przycisk DOBRZE, aby pojawiło się następne.',
        'Jeśli nie rozpoznajesz słowa albo nie masz pewności, kliknij plakietkę ze znakiem „?”: pojawi się tłumaczenie, a lektor przeczyta słowo po angielsku (i po polsku, jeśli w opcjach gry polski lektor jest włączony). Kliknięcie tłumaczenia znów je zakryje.',
        'Jeśli chcesz jeszcze raz wywołać słowo, kliknij przycisk POWTÓRZ. Gra przejdzie do następnego słowa, a to pojawi się ponownie pod koniec gry.',
        'INFO: Przy ostatnim słowie z listy przycisk POWTÓRZ zmienia wygląd. Jeśli go wtedy użyjesz, przed powtórką pojawi się jeszcze jedno, inne słowo z listy.',
      ],
    },
    recognizeEasy: {
      title: 'Moduł PRZECZYTAJ I POWIEDZ CO TO ZNACZY: ',
      items: [
        'Przeczytaj wyświetlone słowo i powiedz, co znaczy. Jeśli wiesz, kliknij przycisk DOBRZE, aby pojawiło się następne.',
        'Jeśli nie wiesz albo nie masz pewności, kliknij plakietkę ze znakiem „?”: pojawi się obrazek (a gdy słowo go nie ma — polskie tłumaczenie), a lektor przeczyta słowo po angielsku (i po polsku, jeśli w opcjach gry polski lektor jest włączony). Kliknięcie obrazka znów go zakryje.',
        'Jeśli chcesz jeszcze raz wywołać słowo, kliknij przycisk POWTÓRZ. Gra przejdzie do następnego słowa, a to pojawi się ponownie pod koniec gry.',
        'INFO: Przy ostatnim słowie z listy przycisk POWTÓRZ zmienia wygląd. Jeśli go wtedy użyjesz, przed powtórką pojawi się jeszcze jedno, inne słowo z listy.',
      ],
    },
    recognize2: {
      title: 'Moduł ROZPOZNAJ TŁUMACZENIE: ',
      items: [
        'Na ekranie pojawia się słowo po polsku. Jeśli w opcjach gry polski lektor jest włączony, lektor je przeczyta.',
        'Jeżeli pamiętasz DOKŁADNIE odpowiednik słowa w obcym języku, świetnie. Kliknij przycisk DOBRZE, aby pojawiło się następne.',
        'Jeśli nie pamiętasz — lub nie masz pewności — kliknij plakietkę ze znakiem „?”: pojawi się odpowiedź, a lektor przeczyta ją po angielsku. Kliknięcie odpowiedzi znów ją zakryje.',
        'Jeśli chcesz jeszcze raz wywołać słowo, kliknij przycisk POWTÓRZ. Gra przejdzie do następnego słowa, a to pojawi się ponownie pod koniec gry.',
        'INFO: Przy ostatnim słowie z listy przycisk POWTÓRZ zmienia wygląd. Jeśli go wtedy użyjesz, przed powtórką pojawi się jeszcze jedno, inne słowo z listy.',
      ],
    },
    recognize2Easy: {
      title: 'Moduł POWIEDZ PO ANGIELSKU: ',
      items: [
        'Na ekranie pojawia się obrazek i słowo po polsku. Jeśli w opcjach gry polski lektor jest włączony, lektor je przeczyta.',
        'Powiedz to słowo po angielsku. Jeśli pamiętasz je DOKŁADNIE, świetnie. Kliknij przycisk DOBRZE, aby pojawiło się następne.',
        'Jeśli nie pamiętasz — lub nie masz pewności — kliknij plakietkę ze znakiem „?”: pojawi się odpowiedź, a lektor przeczyta ją po angielsku. Kliknięcie odpowiedzi znów ją zakryje.',
        'Jeśli chcesz jeszcze raz wywołać słowo, kliknij przycisk POWTÓRZ. Gra przejdzie do następnego słowa, a to pojawi się ponownie pod koniec gry.',
        'INFO: Przy ostatnim słowie z listy przycisk POWTÓRZ zmienia wygląd. Jeśli go wtedy użyjesz, przed powtórką pojawi się jeszcze jedno, inne słowo z listy.',
      ],
    },
    writing: {
      title: 'Moduł NAPISZ: ',
      items: [
        'Ostatnie, najbardziej angażujące zadanie: wpisz tłumaczenie widocznego słowa w języku obcym. Naciśnij ENTER, aby zatwierdzić. Jeżeli zrobisz to poprawnie, pojawi się kolejne słowo.',
        'Jeśli w opcjach gry polski lektor jest włączony, lektor przeczyta każde nowe słowo po polsku.',
        'Błąd spowoduje pojawienie się poprawnej odpowiedzi oraz przycisków WYCZYŚĆ i MAM RACJĘ. Naciśnij ENTER (lub kliknij WYCZYŚĆ), aby wyczyścić pole i spróbować jeszcze raz — słowo wróci wtedy także pod koniec gry.',
        'Przycisk POMIŃ pomija słowo i od razu przechodzi do następnego. Znika po naciśnięciu ENTER.',
        'Poprawne wpisanie kolejnych słów z listy oznacza, że lista opanowana. CONGRATS!!!',
        'INFO: Wielkość liter, liczba spacji i znaki interpunkcyjne nie mają znaczenia. Skrót liczy się jak pełna forma (I’ll = I will), a sb, someone i somebody to to samo. Przedimki a, an, the i „to” na początku możesz pominąć, tak samo jak to, co w haśle stoi w nawiasie. Jeśli hasło ma kilka wariantów rozdzielonych ukośnikiem, wpisz wszystkie — w dowolnej kolejności.',
        'TIP: Ostatecznie jeśli kwestia dotyczy jedynie literówki lub innego niewielkiego błędu, możesz użyć przycisku MAM RACJĘ — gra przejdzie do następnego słowa, a to nie wróci pod koniec gry (oczywiście radzimy nie nadużywać tej funkcji, aby nie zmniejszyć efektywności gry).',
      ],
    },
    writingEasy: {
      title: 'Moduł NAPISZ: ',
      items: [
        'Ostatnie, najbardziej angażujące zadanie: wpisz tłumaczenie widocznego słowa w języku obcym. Naciśnij ENTER, aby zatwierdzić. Jeżeli zrobisz to poprawnie, lektor przeczyta słowo po angielsku i pojawi się kolejne.',
        'Jeśli w opcjach gry polski lektor jest włączony, lektor przeczyta każde nowe słowo po polsku.',
        'Błąd spowoduje pojawienie się poprawnej odpowiedzi oraz przycisków WYCZYŚĆ i MAM RACJĘ. Naciśnij ENTER (lub kliknij WYCZYŚĆ), aby wyczyścić pole i spróbować jeszcze raz — słowo wróci wtedy także pod koniec gry.',
        'Przycisk POMIŃ pomija słowo i od razu przechodzi do następnego. Znika po naciśnięciu ENTER.',
        'Poprawne wpisanie kolejnych słów z listy oznacza, że lista opanowana. CONGRATS!!!',
        'INFO: Wielkość liter, liczba spacji i znaki interpunkcyjne nie mają znaczenia. Skrót liczy się jak pełna forma (I’ll = I will), a sb, someone i somebody to to samo. Przedimki a, an, the i „to” na początku możesz pominąć, tak samo jak to, co w haśle stoi w nawiasie. Jeśli hasło ma kilka wariantów rozdzielonych ukośnikiem, wpisz wszystkie — w dowolnej kolejności.',
        'TIP: Ostatecznie jeśli kwestia dotyczy jedynie literówki lub innego niewielkiego błędu, możesz użyć przycisku MAM RACJĘ — gra przejdzie do następnego słowa, a to nie wróci pod koniec gry (oczywiście radzimy nie nadużywać tej funkcji, aby nie zmniejszyć efektywności gry).',
      ],
    },
    letters: {
      title: 'Moduł LITERUJ: ',
      items: [
        'Program wypowiada kolejne litery słowa. Twoim zadaniem jest kliknięcie w odpowiednią literę spośród rozsypanych liter. Przycisk POSŁUCHAJ powtarza literę, której szukasz.',
        'Jeśli wybierzesz złą literę, podświetli się na czerwono i usłyszysz jeszcze raz literę, której szukasz. Spróbuj ponownie, aby znaleźć właściwą literę.',
        'Po ułożeniu całego słowa zobaczysz 3 obrazki (przy liście z dwoma słowami — 2). Kliknij w ten, który pasuje do słowa.',
        'Jeśli klikniesz w zły obrazek, podświetli się na czerwono, a nad obrazkami pojawi się ułożone słowo. Spróbuj ponownie.',
        'Na koniec program przeliteruje słowo (każda litera oddzielnie) i wypowie całe słowo. Możesz powtórzyć za pomocą przycisku POWTÓRZ, a przyciskiem DALEJ przejdziesz do następnego słowa.',
        'Przycisk POMIŃ pomija słowo i od razu przechodzi do następnego.',
        'TIP: Słuchaj uważnie - każda litera ma swój unikalny dźwięk! To pomoże Ci lepiej zapamiętać wymowę.',
      ],
    },
    dragLetters: {
      title: 'Moduł UŁÓŻ SŁOWA: ',
      items: [
        'Zobaczysz obrazek przedstawiający słowo do ułożenia oraz rozsypane litery. Przycisk POSŁUCHAJ przeczyta słowo po angielsku.',
        'Przeciągnij litery na puste pola, aby ułożyć prawidłowe słowo. Znaki, które nie są literami (np. apostrof, myślnik), stoją już na swoich miejscach.',
        'Możesz zamieniać litery miejscami - przeciągnij jedną literę na pole zajęte przez inną, aby je zamienić.',
        'Gdy ułożysz wszystkie litery, kliknij przycisk SPRAWDŹ, aby sprawdzić odpowiedź.',
        'Jeśli ułożysz słowo poprawnie, zobaczysz potwierdzenie i przycisk DALEJ do następnego słowa.',
        'Jeśli ułożysz słowo błędnie, zobaczysz poprawną wersję słowa. Kliknij WYCZYŚĆ, aby wyczyścić pola i spróbować ponownie.',
        'Słowa z błędami będą powtarzane później w grze.',
        'Przycisk POMIŃ pomija słowo i od razu przechodzi do następnego. Pominięte słowo już nie wróci.',
        'TIP: Zwróć uwagę na obrazek - pomoże Ci zrozumieć, jakie słowo należy ułożyć!',
      ],
    },
  },
};

export default PolishGamesTranslations;
